import React, { Component } from 'react';
import './UsersPage.css';
import Page from '../../components/page/Page';
import UpdateTitle from '../../components/updateTitle/UpdateTitle';
import UsersCard from '../dashboardPage/usersCard/UsersCard';
import DrugAdministrationCard from '../../components/drugAdministrationCard/DrugAdministrationCard';

export default class UsersPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			display_archived: false
		};
	}

	// componentDidMount() {
	// 	this.addTitleToHead();
	// 	console.log("component mounted");
	// }

	// addTitleToHead = () => {
	// 	var x = document.createElement("TITLE");
	// 	var t = document.createTextNode("Users");
	// 	x.appendChild(t);
	// 	document.head.appendChild(x);
	// 	console.log("component appended title");
	//   }


	render() {
		const {display_archived} = this.state;
		return (
			<Page className="g-users-page">
				<UpdateTitle newTitle="Users" originalTitle="LogRx" />
				<UsersCard email invite display_archived={display_archived} />
				<DrugAdministrationCard />
			</Page>
		);
	}
}



// WEBPACK FOOTER //
// ./src/pages/usersPage/UsersPage.jsx